module.exports = __webpack_public_path__ + "static/media/Source Info.4025503e.txt";